import { Component, OnInit } from '@angular/core';
import { Title, Meta } from '@angular/platform-browser';

@Component({
  selector: 'app-concert',
  templateUrl: './concert.component.html',
  styleUrls: ['./concert.component.scss']
})
export class ConcertComponent implements OnInit {

  constructor(
    private title: Title,
    private meta: Meta
  ) { 
    this.title.setTitle("Kerstconcert");
    this.meta.addTag({name: 'description', content: "Naast het dorpsfeest in mei organiseert Tongerlo Leeft ! ook elk jaar in december een openlucht Kerst-Rock-Concert."});
    this.meta.addTag({ name: 'keywords', content: "Kerstconcert Tongerlo, Kerstconcert"})
  }

  ngOnInit() {
  }

}
